/**
 * Sherloc Reports copy that must read identically in Cortex and Quantum.
 *
 * The two pages are large and have drifted from each other in places, so
 * wording shared between them lives here rather than as a literal in each
 * file — one edit, one value, and a parity test that fails if the portals
 * ever disagree about what a control says.
 */

/**
 * The Platform Performance status pill.
 *
 * It describes the INGESTION PIPELINE — live delivery and ingested history
 * resolved through one unified path — and says nothing about whether any
 * individual platform below it is currently delivering. A platform's own
 * LIVE / READY badge is the only claim about that platform, which is why
 * TikTok can read READY while this pill still applies.
 */
export const PLATFORM_PERFORMANCE_INGEST_PILL_COPY = "Live Unified Ingest";
